import { Button } from "@legal-500/legal500-design-system";
import { canApproveOrReject, canSuspend, type ContentStatus } from "../utils";
import styles from "../ContentInboxDetail.module.css";

type DetailDecisionButtonsProps = {
  status: ContentStatus;
  lockedByOther: boolean;
  busy: boolean;
  outputBlank: boolean;
  onSave: () => void;
  onApprove: () => void;
  onReject: () => void;
  onSuspend: () => void;
};

export function DetailDecisionButtons({
  status,
  lockedByOther,
  busy,
  outputBlank,
  onSave,
  onApprove,
  onReject,
  onSuspend,
}: DetailDecisionButtonsProps) {
  const blocked = lockedByOther || busy;

  return (
    <div className={styles.actionsSection}>
      <Button
        variant="contained"
        color="primary"
        onClick={onSave}
        disabled={blocked || status !== "NEW" || outputBlank}
      >
        Save Changes
      </Button>
      {canApproveOrReject(status) && (
        <>
          <Button
            variant="contained"
            color="success"
            onClick={onApprove}
            disabled={blocked || outputBlank}
          >
            Approve
          </Button>
          <Button variant="contained" color="error" onClick={onReject} disabled={blocked}>
            Reject
          </Button>
        </>
      )}
      {canSuspend(status) && (
        <Button variant="contained" color="warning" onClick={onSuspend} disabled={blocked}>
          Suspend
        </Button>
      )}
    </div>
  );
}
